import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import TurnOffAlarmsForm from "./turn-off-alarms-form";
import TurnOffAlarmsData from "./turn-off-alarms-data";

const TurnOffAlarms = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "DEVELOPER_TURN_OFF_ALARMS",
      "DEVELOPER_TURN_OFF_ALARMS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("ALARMS")}
        subTitle={i18n.get("TURN_OFF_ALARMS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <TurnOffAlarmsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <TurnOffAlarmsData />
    </ET3PageDiv>
  );
});
export default TurnOffAlarms;
